import { applyWindow } from './applyWindow';
import { getFunction } from './getFunction';
import { getData } from './utils/getData';
export function compose(shapeOptions) {
    const { length: dataLength, shapes = [] } = shapeOptions;
    const data = new Float64Array(dataLength).fill(1);
    shapes.forEach((options) => {
        const { shape, start = 0 } = options;
        const { options: shapeOptions } = shape;
        const length = 'length' in shapeOptions ? shapeOptions.length : dataLength - start;
        const windowData = getData(getFunction(shape), length);
        applyWindow(data, {
            windowData,
            length,
            start,
            output: data,
        });
    });
    return data;
}
//# sourceMappingURL=compose.js.map